import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetConfigTemplates = (modelId?: string) =>
    useQuery({
        queryKey: ["config-templates", modelId],
        queryFn: async () => {
            const response = await api.get("/api/v1/config-templates", {
                params: modelId ? { modelId } : undefined,
            });
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
        enabled: !!modelId,
    });

export const useCreateConfigTemplate = () =>
    useMutation({
        mutationFn: async (data: any) => {
            const response = await api.post("/api/v1/config-templates", data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["config-templates"] });
        },
    });

export const useUpdateConfigTemplate = () =>
    useMutation({
        mutationFn: async ({ id, data }: { id: string; data: any }) => {
            const response = await api.put(`/api/v1/config-templates/${id}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["config-templates"] });
        },
    });

export const useDeleteConfigTemplate = () =>
    useMutation({
        mutationFn: async (id: string) => {
            const response = await api.delete(`/api/v1/config-templates/${id}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["config-templates"] });
        },
    });
